import { render, staticRenderFns } from "./ReviewsCategories.vue?vue&type=template&id=07057282&"
import script from "./ReviewsCategories.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports